module.exports = __webpack_public_path__ + "img/characteristic-3.cae58b07.png";